import { objectFilter, objectMap, objectValuesMap } from "./mapping";

export const paramsToFilters = (filterKeys = [], params) => {
	return objectValuesMap(
		objectFilter(
			params,
			([k, v]) =>
				filterKeys.includes(k) && (v !== null && v !== undefined)
		),
		(v, k) => {
			if (filterKeys.includes(k)) {
				if (k === "status" || k === "searchType") {
					return v;
				}
				if (k === "page" || k === "pageSize") {
					return typeof v === "number" ? v : Number(v);
				}
				return new Set(typeof v !== "object" ? [v] : v);
			}
		}
	);
};

export const filtersToParams = (filterKeys = [], filters) => {
	return objectMap(
		objectFilter(
			{ ...Object.fromEntries(filterKeys.map(k => [k, {}])), ...filters },
			([k, v]) =>
				filterKeys.includes(k) &&
				(k === "status" || k === "searchType"
					? true
					: v !== null && v !== undefined)
		),
		([k, v]) => {
			if (filterKeys.includes(k)) {
				if (k === "status") {
					if (v === undefined) {
						return [k, "*"];
					}
					if (v instanceof Set) {
						const arr = Array.from(v);
						return [
							k,
							arr.length > 0 ? arr.map(String) : undefined
						];
					}
					if (Array.isArray(v)) {
						return [k, v.length > 0 ? v.map(String) : undefined];
					}
					if (typeof v === "string" && v.length > 0) {
						return [k, v];
					}
					return [k, undefined];
				}

				if (k === "searchType") {
					if (v instanceof Set) {
						const arr = Array.from(v);
						return [k, arr.length > 0 ? arr[0] : undefined];
					}
					if (Array.isArray(v)) {
						return [k, v.length > 0 ? v[0] : undefined];
					}
					if (typeof v === "string" && v.length > 0) {
						return [k, v];
					}
					return [k, undefined];
				}

				if (typeof v === "number") {
					return [k, String(v)];
				}

				if (typeof v == "string" && v.length > 0) {
					return [k, v];
				}

				if (!v.size && !v.length) {
					return [k, undefined];
				}

				return [k, [...v].map(String)];
			}
		}
	);
};

export const cleanFiltersForQuery = filters => {
	return Object.fromEntries(
		Object.entries(filters ?? {})
			.map(([key, value]) => {
				if (value instanceof Set) {
					return [key, Array.from(value).join(",")];
				}
				return [key, value];
			})
			.filter(([_, v]) => v !== undefined && v !== "")
	);
};

const convertToValidType = value => {
	if (typeof value === "string" && !isNaN(value)) {
		const num = Number(value);
		return isNaN(num) ? value : num;
	}
	return value;
};

export const convertFiltersToValidTypes = filters => {
	if (!filters || typeof filters !== "object") {
		return filters;
	}

	return Object.fromEntries(
		Object.entries(filters).map(([key, value]) => {
			if (value === null || value === undefined) {
				return [key, value];
			}
			if (value instanceof Set) {
				return [key, Array.from(value).map(convertToValidType)];
			}

			if (Array.isArray(value)) {
				return [key, value.map(convertToValidType)];
			}

			if (typeof value === "string") {
				return [key, convertToValidType(value)];
			}
			return [key, value];
		})
	);
};
